import { useState, useCallback } from 'react'

export function useCheckComponentExists(): [boolean, (node: unknown) => void] {
  const [isComponentOrElementRendered, setIsComponentOrElementRendered] =
    useState(false)

  // Pass this ref to the component or DOM node
  const callbackRef = useCallback(node => {
    if (node !== null) {
      setIsComponentOrElementRendered(true)
    } else setIsComponentOrElementRendered(false)
  }, [])
  return [isComponentOrElementRendered, callbackRef]
}
